import Insight from "../insightClass";
import React from "react";
import { insight25Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight051 = new Insight(
  "20 June 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight25Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-06-20)",
  "",
  `The Crown Estate‘s auction for Celtic Sea floating offshore wind achieved just 3 GW instead of the 4.5 GW target. EDF/ESB and Equinor each secured 1.5 GW, paying reduced seabed fees of £350/MW. Projects expected by early 2030s amid cost and supply-chain headwinds.`,
  (
    <div>
      <strong>WeBridge Insights</strong>
      <h1>Global Offshore Wind Weekly (2025-06-20)</h1>
      <h2></h2>
      <p style={{ opacity: "0.4", marginTop: "-70px" }}>20 June 2025</p>
      <br />
      <p>
        Welcome to this week's <i>WeBridge Insights</i>, where we provide you
        with the latest updates and key developments from the global offshore
        wind market.
      </p>
      <br />
      <br />
      <br />
      <p>
        At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
        commentary to keep you informed in this fast-evolving industry. Here's
        our roundup of the top stories this week, complete with professional
        insights to help you stay ahead:
      </p>

      <h3>1. UK: Floating wind auction falls short of target</h3>
      <p>
        The Crown Estate‘s auction for Celtic Sea floating offshore wind
        achieved just 3 GW instead of the 4.5 GW target. EDF/ESB and Equinor
        each secured 1.5 GW, paying reduced seabed fees of £350/MW. Projects
        expected by early 2030s amid cost and supply-chain headwinds.
      </p>
      <p>
        <b>WeBridge Insights: </b>
      </p>
      <p>
        The subdued auction underscores persistent financial and logistical
        barriers for floating wind. Reduced seabed fees are helpful but
        insufficient—industry funding and procurement agreements need to evolve.
        Coordination between government, grid operators, and firms is pivotal to
        scale flotating deployment effectively.
      </p>
      <h3>2. UK: US raises national‑security flags over Chinese turbines</h3>
      <p>
        US officials have urged the UK to reconsider allowing China‘s Mingyang
        to build a turbine factory in Scotland, citing security risks tied to
        surveillance and dependency. UK ministers are weighing actions under the
        National Security and Investment Act.
      </p>
      <p>
        <b>WeBridge Insights:</b>
      </p>
      <p>
        This geopolitical tension spotlights a strategic dilemma: balancing
        industrial growth with geopolitical risk. The UK must develop rigorous
        vetting frameworks for turbine manufacturers while ensuring domestic and
        allied supply chain resilience—essential for long-term energy
        independence.
      </p>
      <h3>3. UK: Crown Estate commits £400M to ports and infrastructure</h3>
      <p>
        King Charles III‘s Crown Estate will invest up to £400 million to
        strengthen offshore wind’s supply chain: £350 M for ports and
        manufacturing capacity, and £50 M for early-stage projects. This
        supports offshore wind expansion ahead of 2030 decarbonisation goals.
      </p>
      <p>
        <b>WeBridge Insights: </b>
      </p>
      <p>
        This capital injection is a strategic enabler—enhancing port facilities
        and infrastructure lays the groundwork to build larger turbines
        domestically. Success hinges on synchronized planning with OEMs, ports,
        and workforce development to match the investment with actual project
        deployment velocity.
      </p>
      <h3>4. Europe: France‘s Dieppe Le Tréport substation arrives</h3>
      <p>
        A major substation topside for France‘s 496 MW Dieppe–Le Tréport
        offshore wind farm has arrived in Le Havre, signalling a key
        offshore/offshore-grid milestone.
      </p>
      <p>
        <b>WeBridge Insights: </b>
      </p>
      <p>
        This delivery demonstrates momentum in integrating offshore farms
        efficiently into national grids. It also highlights the importance of
        cross-border manufacturing coordination—France must now focus on timely
        installation and grid testing to prevent deployment bottlenecks.
      </p>
      <h3>5. Europe: Danish port posts record offshore‑wind profits</h3>
      <p>
        Port Esbjerg reported record revenue of £35.8 million in 2024—a 22%
        year-on-year rise—driven largely by offshore wind activity.{" "}
      </p>
      <p>
        <b>WeBridge Insights: </b>
      </p>
      <p>
        This underlines the economic wallet impact of offshore wind on regional
        logistics hubs. With proper foresight, ports can evolve into central
        industrial nodes—a role that warrants strategic investment and long-term
        planning.
      </p>
      <h3>6. Asia: Orsted refocuses on Taiwan, South Korea</h3>
      <p>
        Orsted plans to double down on projects in Taiwan and South Korea, where
        regulatory clarity exists, abandoning exploration of new markets. Its
        valuation slumped 80% since 2021 amid rising costs and delay pressures.
      </p>
      <p>
        <b>WeBridge Insights: </b>
      </p>
      <p>
        Orsted’s disciplined pivot to mature markets is strategically sound.
        These hubs offer regulatory certainty vital for long-term returns. Other
        nations should streamline policy frameworks if they aim to attract
        similar investment—but must also plan supply‑chain and grid readiness.
      </p>
      <h3>7. North America: New Jersey calls wind a growth engine</h3>
      <p>
        A New Jersey Offshore Wind Alliance executive highlighted projects along
        the US East Coast as key to job creation, energy reliability, and lower
        customer bills. Over 1,000 local businesses are already engaged.
      </p>
      <p>
        <b>WeBridge Insights: </b>
      </p>
      <p>
        This narrative reveals the US trend of framing offshore wind as a
        socio-economic lever. Success will depend on inter-state coordination,
        grid upgrades, and skilled-labour investment. Public messaging needs to
        stay credible vis‑à‑vis energy cost and transmission realities.
      </p>

      <br />
      <br />
      <br />
      <p>
        As the global offshore wind sector continues to advance, innovation,
        investments, and supportive policies are driving transformative growth.
        At{" "}
        <i>
          <b>WeBridge</b>
        </i>
        , we provide the expertise and insights our partners need to confidently
        navigate this evolving landscape.
      </p>
      <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
      <ContactSubscribe />
    </div>
  )
);
